import { doRectanglesIntersect } from "../doRectanglesIntersect";
import { getCumulativeOffset } from "../getCumulativeOffset";
import { getCumulativeTransformations } from "../getCumulativeTransformations";

/**
 * Determines if two HTML elements intersect each other.
 */

const isIntersectingRect = (element1: HTMLElement, element2: HTMLElement): boolean => {
  const { transformY, transformX } = getCumulativeTransformations();
  const { height: height1, width: width1 } = element1.getBoundingClientRect();
  const { height: height2, width: width2 } = element2.getBoundingClientRect();
  const x1 = getCumulativeOffset(element1).left + transformX;
  const y1 = getCumulativeOffset(element1).top + transformY;
  const x2 = getCumulativeOffset(element2).left;
  const y2 = getCumulativeOffset(element2).top;

  return doRectanglesIntersect(
    { maxX: x1 + width1, maxY: y1 + height1, minX: x1, minY: y1 },
    { maxX: x2 + width2, maxY: y2 + height2, minX: x2, minY: y2 }
  );
};

export { isIntersectingRect };
